import { createRoot } from "react-dom/client";
import { UserProvider } from "./contexts/UserContext";
import { ModalProvider } from "./contexts/ModalContext";

import { PixlProvider } from "./contexts/PixlContext";
import { CustomizationProvider } from "./contexts/CustomizationContext";
import {
    UUIDProvider,
    ToastProvider,
    WebsocketProvider,
} from "@mythic/coms/ui";

import App from "./App";
import "./fonts.css";
import "./index.css";

// UserContext is provided here
const root = document.getElementById("root");
if (root)
    createRoot(root).render(
        <UUIDProvider>
            <ToastProvider>
                <UserProvider>
                    <ModalProvider>
                        <WebsocketProvider
                            url={import.meta.env.VITE_WEBSOCKET_ADDRESS}
                        >
                            <PixlProvider>
                                <CustomizationProvider>
                                    <App />
                                </CustomizationProvider>
                            </PixlProvider>
                        </WebsocketProvider>
                    </ModalProvider>
                </UserProvider>
            </ToastProvider>
        </UUIDProvider>,
    );
